<template>
    <div id="app">
        <Cover />
        <Intro />
        <Services />
        <Mission />
        <Products />
        <Quote image="quote.jpg" quote="„Dej člověku rybu a nasytíš jej na jeden den, nauč jej rybařit a nasytíš jej na celý život.“" />
        <Testimonials />
        <CallToAction />
        <Team />
        <Quote image="quote-2.jpg" quote="„Kdo chce změnit svět, musí změnit nejdříve sebe.“" :link="quoteLink" />
        <Contact />
    </div>
</template>

<script>
    import Cover from './components/Cover.vue';
    import Intro from './components/Intro.vue';
    import Services from './components/Services.vue';
    import Mission from './components/Mission.vue';
    import Products from './components/Products.vue';
    import Quote from './components/Quote.vue';
    import Testimonials from './components/Testimonials.vue';
    import CallToAction from './components/CallToAction.vue';
    import Team from './components/Team.vue';
    import Contact from './components/Contact.vue';

    export default {
        name: 'App',
        components: {
            Cover,
            Intro,
            Services,
            Mission,
            Products,
            Quote,
            Testimonials,
            CallToAction,
            Team,
            Contact
        },
        data() {
            return {
                quoteLink: {
                    text: 'www.get2knowme.cz',
                    link: 'https://www.get2knowme.cz'
                }
            }
        }
    }
</script>

<style lang="scss">

    @import url('https://fonts.googleapis.com/css2?family=Roboto+Slab:wght@400;600;900&family=Roboto:wght@300;400&display=swap');

    html {
        display: block;
        box-sizing: border-box;
        font-family: 'Roboto', sans-serif;
        font-size: 62.5%;
    }

    body {
        padding: 0;
        border: 0;
        margin: 0;
        font-size: 1.6rem;
        color: #333;
    }

    * {
        box-sizing: border-box;
        color: #333;
    }

    .section {
        padding: 8rem;
    }

    .slick-slider {
        position: relative;
        display: block;
        user-select: none;
        touch-action: pan-y;
        transition: height .15s ease-in-out;
    }

    .slick-track {
        position: relative;
        top: 0;
        left: 0;
        display: block;
        transform: translateZ(0);
        transition: height .15s ease-in-out;
    }

    .slick-list {
        position: relative;
        display: block;
        overflow: hidden;
        padding: 0;
        margin: 0;
        transform: translateZ(0);
        transition: height .15s ease-in-out;
    }

    .slick-slide {
        float: left;
        height: 100%;
        min-height: 1px;
        transition: height .15s ease-in-out;
    }

    .slick-dots li {

        button::before {
            font-size: 12px;
            transition: font-size .15s ease-in-out, color .15s ease-in-out;
        }

        &.slick-active {

            button::before {
                font-size: 16px;
                color: #fad2ca;
            }
        }

        &:not(.slick-active):hover button::before {
            font-size: 14px;
            color: #2c498a;
        }
    }

    .btn {
        display: table;
        padding: 2rem 4rem 1.8rem 4rem;
        border: 0;
        border-radius: .5rem;
        margin: 0 auto;
        box-shadow: 0 3px 0 0 #2c498a;
        letter-spacing: 1px;
        text-transform: uppercase;
        text-decoration: none;
        font-weight: 600;
        background-color: #385dae;
        color: #fff;
        transition: background-color .15s ease-in-out;

        &:hover,
        &:focus,
        &:active {
            background-color: #5173bb;
        }
    }

    @media (max-width: 999px) {

        .section {
            padding: 6rem 4rem;
        }
    }

    @media (max-width: 767px) {

        .section {
            padding: 4rem 2rem;
        }
    }

</style>
